module.exports = __webpack_public_path__ + "img/eminem.3f48c27d.jpg";